import React from 'react';

import $ from 'jquery';
var chars = [];
var code = "";
var bookno = [];
var newcode = '';

function onKeyPress(e, that) {
  if (that.props.startListening)
  {
    chars.push(String.fromCharCode(e.which));
    setTimeout(function () {
      if (chars.length >= 5) {
        var barcode = chars.join("");
        var chkArray = [];
        if ($.inArray(barcode, chkArray) == '-1') {
          chkArray.push(barcode);

          String.prototype.RFIDHexToString = function (delim) {
            if (this.match(/[0-9A-Fa-f]{2}/g) !== null) {

              return this.match(/[0-9A-Fa-f]{2}/g).map(function (c) {
                var intVal = parseInt(c, 16);
                return String.fromCharCode(intVal);
              }).join(delim || "").split("").reverse().join("");
            }
          };

          code = barcode.RFIDHexToString();

          if (code && code.match(/^[a-zA-Z0-9]*/) !== null) {
            code.match(/^[a-zA-Z0-9]*/).map(codeWithoutExtraSymbols => {
              return newcode += codeWithoutExtraSymbols;
            });
          }
          if (!bookno.includes(code)) {
            bookno.push(newcode);
            that.props.fetchBarcode(newcode);

          }
          console.log("converted barcode to bookno = > " + code);
          code = '';
          chars = [];
          barcode = '';
          newcode = '';
        }
      }
    }, 500);
  }

}


function onKeyDownNative(e) {
  if (e) {
    onKeyPress(e, this);
  }
}

class HotkeyListener extends React.Component {

  constructor(props) {

    super(props);
    onKeyDownNative = onKeyDownNative.bind(this);

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetBookno !== this.props.resetBookno) {
      code = '';
      chars = [];
    }
  }

  componentWillMount() {
    console.log('mount');
    window.addEventListener("keydown", onKeyDownNative);
  }

  componentWillUnmount() {
    console.log('unmount');
    window.removeEventListener("keydown", onKeyDownNative);
    code = '';
    chars = [];
    newcode = '';
  }

  render() {
    // Listens to any propagated synthetic keydown events
    return <div onKeyDown={onKeyPress}></div>
  }
}


export default HotkeyListener;


// WEBPACK FOOTER //
// ./src/HotKeyListener.js